import React, { Component } from 'react';

class OutlineWindow extends Component {
    constructor(props){
        super(props)
        this.state={
            position:{
                x:0,
                y:0,
            },
            refPos:{
                x:0,
                y:0
            },
            divSize:{
                width:0,
                height:0,
            },
            refDivSize:{
                width:0,
                height:0
            },
            containerExtending:false,
        }
   
    }
    componentDidMount(){
        this.setState({
            divSize:this.props.originalImageSize,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log('Outline componentDidUpdate')
        if(this.state.containerExtending === true)
        {
            if(prevProps.mousePos !== this.props.mousePos)
            {
                this.setNewContainerSize()
            } 
        }

        if(prevProps.originalImageSize !== this.props.originalImageSize)
        {
            this.setState({
                divSize:this.props.originalImageSize
            })
        }

        if(prevProps.dynamicImageSize !== this.props.dynamicImageSize)
        {
            //console.log("B1")
            if(this.props.originalImageSize.width && this.props.dynamicImageSize)
            {
                //console.log("B2")
                if(this.state.divSize.width !== Number(this.props.dynamicImageSize.width) || this.state.divSize.height !== Number(this.props.dynamicImageSize.height))
                {
                    //console.log("B3")
                    //console.log(this.state.divSize.width)
                    //console.log(Number(this.props.dynamicImageSize.width))
                    //console.log(this.state.divSize.height)
                    //console.log(Number(this.props.dynamicImageSize.height))

                    this.setState({
                        divSize:
                        {
                            width:Number(this.props.dynamicImageSize.width),
                            height:Number(this.props.dynamicImageSize.height)
                        }
                    },()=>{
                        this.props.getDynamicImageSize(this.state.divSize)
                    })
                }
            }
        }
    }

    setNewContainerSize=()=>{

        //console.log("OutlineWindow setNewContainerSize...")
        let width = this.state.refDivSize.width+(this.props.mousePos.x-this.state.refPos.x)
        let height = this.state.refDivSize.height+(this.props.mousePos.y-this.state.refPos.y)
       
        let newSize = {
            width:width,
            height:height
        }
   
        this.setState({
            divSize: this.borderCollisonForExtending(newSize) ,
        },()=>{
            this.props.getDynamicImageSize(this.state.divSize)
        })
        //this.props.getDynamicImageSize(msg)
    }

    borderCollisonForExtending=(size)=>{
        if(size.width+this.state.position.x>this.props.originalImageSize.width)
        {
            size.width = this.props.originalImageSize.width-this.state.position.x
        }

        if(size.height+this.state.position.y>this.props.originalImageSize.height)
        {
            size.height = this.props.originalImageSize.height-this.state.position.y
        }

        return size

    }

    extendAreaMouseDown=(e)=>{
        //console.log('OutlineWindow extendAreaMouseDown....')
        e.stopPropagation()
        this.setState({
            containerExtending:true,
            refPos:{
                x:e.clientX,
                y:e.clientY
            },
            refDivSize:this.state.divSize
        })   

        let msg ={
            conID:2,
            containerExtending:true,
        }
        this.props.containerExtending(msg)
    }

    extendAreaMouseUp=(e)=>{
        e.stopPropagation()
        this.setState({
            containerExtending:false,
            refPos:{
                x:0,
                y:0
            },
        })  

        let msg ={
            conID:2,
            containerExtending:false,
        }
        
        this.props.containerExtending(msg)
    }


    render(){
        let extendFunctionAreaStyle = {
            width:'20px',
            height:'20px',
            position:'absolute',
            right:'0px',
            bottom:'0px',
            userSelect:'none',
            color:"#ffaa00",
            cursor:'nw-resize'
        }

        let outlineAreaStyle={
            position:'absolute',
            left:"0px",
            top:"0px",
            width:this.state.divSize.width,
            height:this.state.divSize.height,
            outline:"3px dashed #ffaa00",
            outlineOffset:"-3px"
        }

        return(       
            <div style={outlineAreaStyle}>
                <div style={extendFunctionAreaStyle} onMouseDown={this.extendAreaMouseDown}  onMouseUp={this.extendAreaMouseUp}>
                    &#9499;
                </div>
            </div>
      
        )
    }
}

export default OutlineWindow